import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from 'src/app/core/auth/services/token.service';
import { BaseService } from 'src/app/core/services/base.service';
import { ResultSearchModel } from '../../../shared/components/base-resource-form/model/result-search.model';
import { BookingModel } from '../models/booking.model';
import { VoucherPrintModel } from '../models/voucher-print.model';

@Injectable({
  providedIn: 'root'
})
export class BookingService extends BaseService<BookingModel | any, string> {

  constructor(protected injector: Injector, private tokenService: TokenService) {
    super(injector, '/api/booking');
  }

  public pageableSearch(queryString: string): Observable<ResultSearchModel<BookingModel>> {
    return this.search(queryString);
  }

  public update(agent: BookingModel) {
    return this.post(agent, `/edit/${agent.id}`);
  }

  public getStatus(): Observable<any> {
    return this.get('/status');
  }

  public bookingTypes(): Observable<any> {
    return this.get('/booking-types');
  }

  public getBooking(id: string): Observable<any> {
    return this.get(`/${id}`);
  }

  public getVoucher(id: any, type: any): Observable<any> {
    return this.get(`/voucher/${id}?emailVoucherType=${type}`);
  }

  public cancelBooking(id: number, reason: any): Observable<any> {
    return this.put(`${id}`, reason, '/hotel/cancel');
  }

  public getTicketInformations(bookingId: any): Observable<any> {
    return this.get(`/locators/${bookingId}`)
  }

  public postTicketInformations(flightLocators: any): Observable<any> {
    return this.post(flightLocators, `/locators`)
  }

  public recalculatePreview(bookingId: any, request: any): any {
    return this.post(request, `/${bookingId}/recalculate/preview`)
  }

  public recalculateApply(bookingId: any, request: any): any {
    return this.post(request, `/${bookingId}/recalculate/apply`)
  }

  public updateInsuranceLocator(bookingId: any, insuranceBookingId: any, locator: any): Observable<any> {
    return this.patch(`${bookingId}/insurance/${insuranceBookingId}/locator`, locator);
  }

  public commissionLimits(bookingId: any): any {
    return this.get(`/${bookingId}/commission-limits`)
  }

  public canDownloadVoucher(bookingId: any): Observable<any> {
    return this.get(`/${bookingId}/can-download-voucher`)
  }

  public adminDownloadVoucher(obj: VoucherPrintModel, bookingId: any) {
    return this.post(obj, `/admin/${bookingId}/download-voucher`);
  }

  public agentDownloadVoucher(obj: VoucherPrintModel, bookingId: any) {
    return this.post(obj, `/agent/${bookingId}/download-voucher`);
  }

  public adminSendBookingVoucherEmail(obj: any, bookingId: any) {
    return this.post(obj, `/admin/send-booking-voucher-email/${bookingId}`);
  }

  public agentSendBookingVoucherEmail(obj: any, bookingId: any) {
    return this.post(obj, `/agent/send-booking-voucher-email/${bookingId}`);
  }

  public getBookingLog(bookingId: any): Observable<any> {
    return this.http.get<any>(`${environment.apiBaseUrl}/api/booking-log/${bookingId}`, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  isAgent(): boolean {
    const token = this.tokenService.getToken('userToken');
    const user = this.tokenService.decodeToken(token);
    return user.role === 'AGENT';
  }
}
